import Vue from 'vue'
import Vuex from 'vuex'
import VuexI18n from 'vuex-i18n' // load vuex i18n module
import app from './modules/app'
import { authentication } from './modules/authentication.module'
import { loading } from './modules/loading.module'
import { servicos156 } from './modules/serv156.module'
import { servicosSME } from './modules/sme.module'
import { iframeDashboard } from './modules/iframeDashboard.module'
import { privilegio } from './modules/privilegio.module'
import { perfil } from './modules/perfil.module'
import { unidade } from './modules/unidade.module'
import { usuario } from './modules/usuario.module'
import { populacao } from './modules/populacao.module'
import { mobilidade } from './modules/mobilidade.module'
import { saude } from './modules/saude.module'
import { orcamento } from './modules/orcamento.module'
import { parametrizacao } from './modules/parametrizacao.module'
import { empreenda } from './modules/empreenda.module'
import { regiao } from './modules/regiao.module'
import { funcionalismo } from './modules/funcionalismo.module'
import { assistenciaSocial } from './modules/assistenciaSocial.module'
import { covid } from './modules/covid.module'
import { ouvidoria } from './modules/ouvidoria.module'
import { cache } from './modules/dataCache.module'
import { metaDados } from './modules/metaDados.module'
import { transportes } from './modules/transportes.module'
import { sp360Analytics } from './modules/Sp360Analytics.module'
import * as getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  strict: true, // process.env.NODE_ENV !== 'production',
  getters,
  modules: {
    app,
    authentication,
    loading,
    servicos156,
    iframeDashboard,
    privilegio,
    perfil,
    usuario,
    unidade,
    populacao,
    mobilidade,
    saude,
    servicosSME,
    parametrizacao,
    orcamento,
    empreenda,
    regiao,
    funcionalismo,
    assistenciaSocial,
    covid,
    ouvidoria,
    cache,
    metaDados,
    transportes,
    sp360Analytics,
  },
  state: {},
  mutations: {},
})

Vue.use(VuexI18n.plugin, store)

export default store
